import UsersView from "../UsersView.vue";
import UserList from "../Pages/UserList.vue";
import UserEditor from "../Pages/UserEditor.vue";

const routes = [
  {
    path: '/admin/users',
    component: UsersView,
    children: [
      {
        path: '',
        name: 'user-list',
        component: UserList
      },
      {
        path: 'create',
        name: 'user-create',
        component: UserEditor,
      },
      {
        path: ':id/edit',
        name: 'user-edit',
        component: UserEditor,
      }
    ]
  }
]

export default routes
